import { Link } from "react-router-dom";
import { InstaPassLogo } from "../Components/layout/Components/InstaPassLogo";

/* ═══════════════════════════════════════════════════════════════════
   ORIGINAL InstaPointsPage — commented out, preserved for reference
   ═══════════════════════════════════════════════════════════════════

import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import {
  User, Trophy, Target, Award, Clock, ChevronRight, Flame, Zap, Star,
  Crown, Shield, Lock, MapPin, Music, Calendar, TrendingUp, Users,
  Ticket, CheckCircle2, Sparkles, BarChart3, Heart, PartyPopper
} from "lucide-react";
import { Link } from "react-router-dom";
import { InstaPassLogo } from "../Components/layout/Components/InstaPassLogo";
import { ApiMediaURL } from "../setting/GlobleVariable";
import accountimage from "../assets/no_image_user.png";

[... full 884-line InstaPointsPage component — see git history ...]

   ═══════════════════════════════════════════════════════════════════ */

// ─── INLINE STYLES & ANIMATIONS ─────────────────────────────────────
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700;800;900&family=Inter:wght@400;500;600&display=swap');

  @keyframes ip-float {
    0%, 100% { transform: translateY(0px) rotate(0deg) scale(1); }
    33%       { transform: translateY(-16px) rotate(2deg) scale(1.02); }
    66%       { transform: translateY(-8px) rotate(-1.5deg) scale(0.99); }
  }
  @keyframes ip-orbit {
    from { transform: rotate(0deg) translateX(54px) rotate(0deg); }
    to   { transform: rotate(360deg) translateX(54px) rotate(-360deg); }
  }
  @keyframes ip-orbit2 {
    from { transform: rotate(120deg) translateX(54px) rotate(-120deg); }
    to   { transform: rotate(480deg) translateX(54px) rotate(-480deg); }
  }
  @keyframes ip-orbit3 {
    from { transform: rotate(240deg) translateX(54px) rotate(-240deg); }
    to   { transform: rotate(600deg) translateX(54px) rotate(-600deg); }
  }
  @keyframes ip-shimmer {
    0%   { background-position: -300% center; }
    100% { background-position: 300% center; }
  }
  @keyframes ip-fade-up {
    from { opacity: 0; transform: translateY(28px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes ip-pulse-glow {
    0%, 100% { box-shadow: 0 0 30px rgba(212,168,75,0.15), 0 0 60px rgba(229,35,36,0.08); }
    50%       { box-shadow: 0 0 50px rgba(212,168,75,0.3),  0 0 90px rgba(229,35,36,0.15); }
  }
  @keyframes ip-dot-bounce {
    0%, 80%, 100% { transform: scale(0.55); opacity: 0.35; }
    40%           { transform: scale(1);    opacity: 1;    }
  }
  @keyframes ip-spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
  @keyframes ip-counter-spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(-360deg); }
  }
  @keyframes ip-star-twinkle {
    0%, 100% { opacity: 0.15; transform: scale(0.8); }
    50%       { opacity: 0.7;  transform: scale(1.1); }
  }

  .ip-float       { animation: ip-float 7s ease-in-out infinite; }
  .ip-pulse-glow  { animation: ip-pulse-glow 3s ease-in-out infinite; }
  .ip-spin        { animation: ip-spin 18s linear infinite; }
  .ip-counter-spin{ animation: ip-counter-spin 12s linear infinite; }

  .ip-fade-up-1   { animation: ip-fade-up 0.65s ease forwards 0.05s; opacity: 0; }
  .ip-fade-up-2   { animation: ip-fade-up 0.65s ease forwards 0.22s; opacity: 0; }
  .ip-fade-up-3   { animation: ip-fade-up 0.65s ease forwards 0.38s; opacity: 0; }
  .ip-fade-up-4   { animation: ip-fade-up 0.65s ease forwards 0.52s; opacity: 0; }
  .ip-fade-up-5   { animation: ip-fade-up 0.65s ease forwards 0.66s; opacity: 0; }

  .ip-shimmer-text {
    background: linear-gradient(
      90deg,
      #D4A84B 0%, #F5D98A 25%, #ffffff 50%, #F5D98A 75%, #D4A84B 100%
    );
    background-size: 300% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: ip-shimmer 4s linear infinite;
  }

  .ip-orbit-dot-1 { animation: ip-orbit  9s linear infinite; }
  .ip-orbit-dot-2 { animation: ip-orbit2 9s linear infinite; }
  .ip-orbit-dot-3 { animation: ip-orbit3 9s linear infinite; }

  .ip-dot { animation: ip-dot-bounce 1.4s ease-in-out infinite; }
  .ip-dot:nth-child(2) { animation-delay: 0.2s; }
  .ip-dot:nth-child(3) { animation-delay: 0.4s; }

  .ip-star { animation: ip-star-twinkle 2.5s ease-in-out infinite; }
  .ip-star:nth-child(2) { animation-delay: 0.6s; }
  .ip-star:nth-child(3) { animation-delay: 1.1s; }
  .ip-star:nth-child(4) { animation-delay: 1.7s; }
  .ip-star:nth-child(5) { animation-delay: 0.3s; }
  .ip-star:nth-child(6) { animation-delay: 2.0s; }

  .ip-feature-card:hover {
    background: rgba(212,168,75,0.07) !important;
    border-color: rgba(212,168,75,0.2) !important;
    transform: translateY(-3px);
  }
  .ip-feature-card { transition: all 0.25s ease; }

  .ip-btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 52px rgba(229,35,36,0.5) !important;
  }
  .ip-btn-ghost:hover {
    background: rgba(212,168,75,0.08) !important;
    border-color: rgba(212,168,75,0.3) !important;
    color: #D4A84B !important;
    transform: translateY(-2px);
  }
  .ip-btn-primary, .ip-btn-ghost { transition: all 0.25s ease; }
`;

// ─── STAR PARTICLES ─────────────────────────────────────────────────
const STARS = [
  { top: "12%", left: "8%", size: 4, delay: 0 },
  { top: "22%", left: "88%", size: 3, delay: 0.6 },
  { top: "62%", left: "5%", size: 5, delay: 1.1 },
  { top: "75%", left: "92%", size: 3, delay: 1.7 },
  { top: "40%", left: "96%", size: 4, delay: 0.3 },
  { top: "85%", left: "15%", size: 3, delay: 2.0 },
];



// ─── CROWN / TROPHY ICON ────────────────────────────────────────────
function TrophyIcon() {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Cup body */}
      <path
        d="M15 8h30l-4 22c-1 5-5 9-11 9s-10-4-11-9L15 8z"
        fill="rgba(212,168,75,0.18)"
        stroke="#D4A84B"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* Handles */}
      <path d="M15 12H8a6 6 0 0 0 6 6" stroke="#D4A84B" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <path d="M45 12h7a6 6 0 0 1-6 6" stroke="#D4A84B" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      {/* Stem */}
      <rect x="26" y="39" width="8" height="8" rx="2" fill="rgba(212,168,75,0.25)" stroke="#D4A84B" strokeWidth="1.2" />
      {/* Base */}
      <rect x="19" y="47" width="22" height="5" rx="2.5" fill="rgba(212,168,75,0.18)" stroke="#D4A84B" strokeWidth="1.2" />
      {/* Star shine */}
      <circle cx="30" cy="22" r="3" fill="#F5D98A" opacity="0.7" />
      <circle cx="24" cy="18" r="1.5" fill="#D4A84B" opacity="0.5" />
      <circle cx="36" cy="18" r="1.5" fill="#D4A84B" opacity="0.5" />
    </svg>
  );
}

// ─── MAIN COMPONENT ─────────────────────────────────────────────────
export default function InstaPointsPage() {
  return (
    <>
      <style>{styles}</style>

      <div
        style={{
          minHeight: "100vh",
          background: "#0B0F19",
          color: "#fff",
          fontFamily: "'Inter', sans-serif",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* ── Background glows ── */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(ellipse 55% 45% at 50% -5%, rgba(212,168,75,0.10) 0%, transparent 65%)," +
              "radial-gradient(ellipse 40% 35% at 50% 100%, rgba(229,35,36,0.07) 0%, transparent 60%)," +
              "radial-gradient(ellipse 30% 30% at 90% 30%, rgba(229,35,36,0.05) 0%, transparent 60%)",
            pointerEvents: "none",
          }}
        />

        {/* ── Grid overlay ── */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.018) 1px, transparent 1px)," +
              "linear-gradient(90deg, rgba(255,255,255,0.018) 1px, transparent 1px)",
            backgroundSize: "52px 52px",
            pointerEvents: "none",
          }}
        />

        {/* ── Floating star particles ── */}
        {STARS.map((s, i) => (
          <div
            key={i}
            className="ip-star"
            style={{
              position: "absolute",
              top: s.top,
              left: s.left,
              width: s.size,
              height: s.size,
              borderRadius: "50%",
              background: "#D4A84B",
              animationDelay: `${s.delay}s`,
              pointerEvents: "none",
            }}
          />
        ))}

        {/* ── Header ── */}
        <header
          style={{
            height: 64,
            background: "rgba(11,15,25,0.82)",
            backdropFilter: "blur(20px)",
            borderBottom: "1px solid rgba(255,255,255,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 40px",
            position: "sticky",
            top: 0,
            zIndex: 50,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <Link to="/" style={{ flexShrink: 0 }}>
              <InstaPassLogo size="sm" />
            </Link>
            <span style={{ color: "rgba(255,255,255,0.07)", fontSize: 14 }}>|</span>
            <span
              style={{
                fontSize: 13,
                fontWeight: 600,
                fontFamily: "'Outfit', sans-serif",
                color: "rgba(255,255,255,0.4)",
              }}
            >
              InstaPoints
            </span>
          </div>

          <Link
            to="/"
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: "#D4A84B",
              textDecoration: "none",
            }}
            onMouseEnter={e => (e.currentTarget.style.color = "#F5D98A")}
            onMouseLeave={e => (e.currentTarget.style.color = "#D4A84B")}
          >
            ← Home
          </Link>
        </header>

        {/* ── Main ── */}
        <main
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "calc(100vh - 64px)",
            padding: "64px 24px 80px",
            textAlign: "center",
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* ── Orbiting dots + floating icon ── */}
          <div className="ip-fade-up-1" style={{ position: "relative", width: 130, height: 130, marginBottom: 40 }}>
            {/* Outer spinning ring */}
            <div
              className="ip-spin"
              style={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                border: "1px dashed rgba(212,168,75,0.18)",
              }}
            />
            {/* Inner counter-spin ring */}
            <div
              className="ip-counter-spin"
              style={{
                position: "absolute",
                inset: 14,
                borderRadius: "50%",
                border: "1px solid rgba(229,35,36,0.12)",
              }}
            />

            {/* Orbit dots */}
            {["ip-orbit-dot-1", "ip-orbit-dot-2", "ip-orbit-dot-3"].map((cls, i) => (
              <div
                key={i}
                className={cls}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: -4,
                  marginLeft: -4,
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: i === 0 ? "#D4A84B" : i === 1 ? "#E52324" : "#F5D98A",
                  opacity: 0.85,
                  boxShadow: `0 0 8px ${i === 0 ? "#D4A84B" : i === 1 ? "#E52324" : "#F5D98A"}`,
                }}
              />
            ))}

            {/* Center icon */}
            <div
              className="ip-float ip-pulse-glow"
              style={{
                position: "absolute",
                inset: 18,
                borderRadius: "50%",
                background:
                  "linear-gradient(135deg, rgba(212,168,75,0.15) 0%, rgba(229,35,36,0.1) 100%)",
                border: "1px solid rgba(212,168,75,0.25)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TrophyIcon />
            </div>
          </div>

          {/* ── Badge label ── */}
          <div className="ip-fade-up-1" style={{ marginBottom: 18 }}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 7,
                padding: "5px 16px",
                borderRadius: 999,
                background: "rgba(212,168,75,0.09)",
                border: "1px solid rgba(212,168,75,0.22)",
                fontSize: 11,
                fontWeight: 700,
                color: "#D4A84B",
                letterSpacing: "0.09em",
                textTransform: "uppercase",
                cursor: "default",
              }}
            >
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  background: "#D4A84B",
                  display: "inline-block",
                  boxShadow: "0 0 6px #D4A84B",
                }}
              />
              InstaPoints Rewards
            </span>
          </div>

          {/* ── Heading ── */}
          <h1
            className="ip-fade-up-2 ip-shimmer-text"
            style={{
              fontSize: "clamp(38px, 7vw, 64px)",
              fontWeight: 900,
              fontFamily: "'Outfit', sans-serif",
              lineHeight: 1.08,
              marginBottom: 18,
              letterSpacing: "-0.025em",
            }}
          >
            Coming Soon
          </h1>

          {/* ── Sub-text ── */}
          <p
            className="ip-fade-up-3"
            style={{
              fontSize: 15,
              color: "rgba(255,255,255,0.36)",
              lineHeight: 1.75,
              maxWidth: 460,
              marginBottom: 14,
            }}
          >
            We're building a powerful rewards experience — earn points, climb tiers,
            unlock badges, and get rewarded for every event you attend.
          </p>
          <p
            className="ip-fade-up-3"
            style={{
              fontSize: 13,
              color: "rgba(212,168,75,0.55)",
              fontWeight: 600,
              marginBottom: 44,
              letterSpacing: "0.02em",
            }}
          >
            ✦ Your loyalty, rewarded
          </p>



          {/* ── Animated loading dots ── */}
          <div
            className="ip-fade-up-4"
            style={{ display: "flex", gap: 8, marginBottom: 44 }}
          >
            {[0, 1, 2].map(i => (
              <span
                key={i}
                className="ip-dot"
                style={{
                  width: 9,
                  height: 9,
                  borderRadius: "50%",
                  background: i === 1 ? "#E52324" : "#D4A84B",
                  display: "inline-block",
                  boxShadow: `0 0 8px ${i === 1 ? "#E52324" : "#D4A84B"}60`,
                }}
              />
            ))}
          </div>

          {/* ── CTAs ── */}
          <div
            className="ip-fade-up-5"
            style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}
          >
            <Link
              to="/"
              className="ip-btn-primary"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "14px 32px",
                borderRadius: 16,
                background: "linear-gradient(135deg, #E52324 0%, #C41E1E 100%)",
                color: "#fff",
                fontSize: 13,
                fontWeight: 800,
                textDecoration: "none",
                boxShadow: "0 10px 36px rgba(229,35,36,0.32)",
                letterSpacing: "0.01em",
              }}
            >
              ← Back to Home
            </Link>

            <Link
              to="/tickets"
              className="ip-btn-ghost"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "14px 28px",
                borderRadius: 16,
                background: "transparent",
                border: "1px solid rgba(212,168,75,0.18)",
                color: "rgba(212,168,75,0.7)",
                fontSize: 13,
                fontWeight: 700,
                textDecoration: "none",
                letterSpacing: "0.01em",
              }}
            >
              Browse Events →
            </Link>
          </div>
        </main>
      </div>
    </>
  );
}
